import axios from '@/plugins/axios';

export async function remove(orgId){
    return await axios.delete(`admin/organizations/${orgId}`);
}